import React from 'react'
import Cards from 'src/app/Cards/Cards'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import CardsPhysicalCardsAppRoute from 'src/navigation/appRoutes/cards/cardsPhysicalCards.appRoute'
import { cardsRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const CardsAppRoute: AppRoute = {
  id: AppLocation.Cards,
  routeProps: cardsRouteProps,
  component: <Cards />,
  subRoutes: [CardsPhysicalCardsAppRoute],
  meta: { contentType: SidenavContentType.Main },
}

export default CardsAppRoute
